import { defineNuxtRouteMiddleware, navigateTo, useNuxtApp } from '#imports'
import { useAuthService } from '@b2ag/auth'
import { getAppContext } from '@b2ag/micro-front-tools'
import { setCurrency } from '@b2ag/locale'
import { useUserData, useUserSegments } from '@b2ag/user-data'
import { initAxeptioIfNeeded } from '../helpers/axeptio.helper'

const { isFrontAgri } = getAppContext()

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (import.meta.server || to.meta.oauthWorkflow) return

  const userData = useUserData()
  const isAuthenticated = await useAuthService().isAuthenticated()
  userData.setAuthenticated(isAuthenticated)

  if (isAuthenticated) {
    const storeInstance = useNuxtApp().$store as any

    if (!userData.isUserLoaded.value) {
      try {
        await storeInstance.dispatch('fetchUser')
      } catch {
        return navigateTo({ name: 'auth-callback-error', query: { error_code: 'FETCH_USER_ERROR' } })
      }

      // Verify currentProfile sync (agri only)
      if (isFrontAgri) {
        const { getUserCurrentCustomerUseCase } = await import('@b2ag/micro-front-my-account-sdk/switch-profile')
        const currentProfileCustomer = await getUserCurrentCustomerUseCase.execute()
        const isOutOfSync =
          currentProfileCustomer && Number(userData.currentProfileId.value) !== currentProfileCustomer.id_profile

        if (isOutOfSync) {
          const found = userData.profiles.value?.find((p: any) => +p.id === currentProfileCustomer.id_profile)
          if (found) await storeInstance.dispatch('switchProfile', found)
        }
      }

      // Segments (agri only)
      if (isFrontAgri) {
        const { fetchFreshUserSegments } = useUserSegments()
        const cartData = storeInstance.getters['cart/cart']
        const partnerId = String(userData.currentDistributorId.value ?? '')
        const customerCode = userData.currentMembershipNumber.value

        if (partnerId && customerCode) {
          await fetchFreshUserSegments({ cartData, customerCode, partnerId })
        }
      }

      // Currency + Axeptio
      const currency = isFrontAgri
        ? userData.currentProfile.value?.cooperative?.currency
        : userData.user.value?.cooperatives?.[0]?.currency
      setCurrency(currency)
      initAxeptioIfNeeded(userData.consentToken.value)
    }
  } else if (to.name !== 'auth-callback' && from.name !== 'auth-callback') {
    initAxeptioIfNeeded(userData.consentToken.value)
    const { areUserSegmentsEmpty, updateUserSegments } = useUserSegments()
    if (!areUserSegmentsEmpty()) updateUserSegments([])
  }
})
